import * as z from 'zod';

export const WhereAreYouStartSchema = z.object({
  name: z.string().min(1, { message: 'Nombre es requerido' }),
});
export type WhereAreYouStartData = z.infer<typeof WhereAreYouStartSchema>;

export const TypeOfOrganizationSchema = z.object({
  type: z.string().min(1, { message: 'Tipo es requerido' }),
});
export type TypeOfOrganizationData = z.infer<typeof TypeOfOrganizationSchema>;

export const BusinessAddressSchema = z.object({
  legalName: z.string().min(1, { message: 'Nombre es requerido' }),
  taxId: z.string().optional(),
  whatYourCompanyDoes: z.string().optional(),
  country: z.string().min(1, { message: 'País es requerido' }),
  state: z.string().min(1, { message: 'Estado o Departamento es requerido' }),
  address1: z.string().min(1, { message: 'Dirección es requerida' }),
  postalCode: z.string().min(1, { message: 'Código Postal es requerido' }),
});
export type BusinessAddressData = z.infer<typeof BusinessAddressSchema>;

export const TeamMemberSchema = z.object({
  id: z.string().min(1, { message: 'Id es requerido' }),
  name: z.string().min(1, { message: 'Nombre completo es requerido' }),
  email: z.string().min(1, { message: 'Email es requerido' }),
  role: z.string().min(1, { message: 'Rol es requerido' }),
});
export type TeamMemberData = z.infer<typeof TeamMemberSchema>;

export type OrganizationForm = {
  whereAreYouStart: WhereAreYouStartData;
  typeOfOrganization: TypeOfOrganizationData;
  businessAddress: BusinessAddressData;
  teamMembers: TeamMemberData[];
};
